import { ICorrespondantWebServiceClient } from "@resources/resources";
import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";

@Injectable()
export class CorrespondantTagsResolver implements Resolve<Array<string>> {

  constructor(private correspondantWebservice: ICorrespondantWebServiceClient) {
  }

  resolve() {
    return this.correspondantWebservice.getTags();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/correspondants-tags.resolver.ts